import { createStore } from 'zustand/vanilla';
import { devtools } from 'zustand/middleware';
import { SELECTED_STORE, SEARCH_DETAILS } from './utils/local-storage-keys';
import updateLocationSideEffect from './utils/update-location-side-effect';
import getWebShellClientLocale from "../../utils/get-webshellclient-locale";
import trackEvent, { LOCATION_UPDATED } from "../../analytics/track-event";
var isSelectedStoreEqual = function isSelectedStoreEqual(_ref) {
  var newStore = _ref.newStore,
    currentStore = _ref.currentStore;
  return (newStore === null || newStore === void 0 ? void 0 : newStore.id) === (currentStore === null || currentStore === void 0 ? void 0 : currentStore.id);
};
var isLocationSearchEqual = function isLocationSearchEqual(_ref2) {
  var _newSearch$coordinate, _currentSearch$coordi, _newSearch$coordinate2, _currentSearch$coordi2;
  var newSearch = _ref2.newSearch,
    currentSearch = _ref2.currentSearch;
  return newSearch.postCode === currentSearch.postCode && ((_newSearch$coordinate = newSearch.coordinates) === null || _newSearch$coordinate === void 0 ? void 0 : _newSearch$coordinate.latitude) === ((_currentSearch$coordi = currentSearch.coordinates) === null || _currentSearch$coordi === void 0 ? void 0 : _currentSearch$coordi.latitude) && ((_newSearch$coordinate2 = newSearch.coordinates) === null || _newSearch$coordinate2 === void 0 ? void 0 : _newSearch$coordinate2.longitude) === ((_currentSearch$coordi2 = currentSearch.coordinates) === null || _currentSearch$coordi2 === void 0 ? void 0 : _currentSearch$coordi2.longitude);
};
var createRetailMFEStore = function createRetailMFEStore() {
  return createStore(devtools(function (set, get) {
    var _selectedStore, _selectedStore2, _getWebShellClientLoc;
    var selectedStore = JSON.parse(window.localStorage.getItem(SELECTED_STORE));
    var locationSearch = JSON.parse(window.localStorage.getItem(SEARCH_DETAILS)) || {
      coordinates: {
        latitude: null,
        longitude: null
      },
      postCode: null
    };

    // if selectedStore country isn't the same as current experience country, clear the store and search details
    if (Boolean((_selectedStore = selectedStore) === null || _selectedStore === void 0 || (_selectedStore = _selectedStore.address) === null || _selectedStore === void 0 ? void 0 : _selectedStore.iso2Country) && ((_selectedStore2 = selectedStore) === null || _selectedStore2 === void 0 || (_selectedStore2 = _selectedStore2.address) === null || _selectedStore2 === void 0 ? void 0 : _selectedStore2.iso2Country) !== ((_getWebShellClientLoc = getWebShellClientLocale().country) === null || _getWebShellClientLoc === void 0 ? void 0 : _getWebShellClientLoc.toUpperCase())) {
      window.localStorage.removeItem(SELECTED_STORE);
      window.localStorage.removeItem(SEARCH_DETAILS);
      selectedStore = null;
      locationSearch = {
        coordinates: {
          latitude: null,
          longitude: null
        },
        postCode: null
      };
    }
    return {
      selectedStore: selectedStore,
      locationSearch: locationSearch,
      setSelectedStore: function setSelectedStore(selectedStore) {
        if (!isSelectedStoreEqual({
          newStore: selectedStore,
          currentStore: get().selectedStore
        })) {
          updateLocationSideEffect();
          trackEvent(LOCATION_UPDATED, {}, {
            usePageAction: true
          });
          set({
            selectedStore: selectedStore
          });
        }
      },
      setLocationSearch: function setLocationSearch(locationSearch) {
        if (!isLocationSearchEqual({
          newSearch: locationSearch,
          currentSearch: get().locationSearch
        })) {
          updateLocationSideEffect();
          trackEvent(LOCATION_UPDATED, {}, {
            usePageAction: true
          });
          set({
            locationSearch: locationSearch
          });
        }
      }
    };
  }, {
    name: 'Retail MFE',
    enabled: process.env.NODE_ENV === 'development'
  }));
};
export default createRetailMFEStore;